import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { createElement } from 'react-native-web';
import { resolve } from './lib/resolve';
import { Component } from 'react';

function prepare(props) {
  var translate = props.translate,
      scale = props.scale,
      rotation = props.rotation,
      skewX = props.skewX,
      skewY = props.skewY,
      originX = props.originX,
      originY = props.originY,
      fontFamily = props.fontFamily,
      fontSize = props.fontSize,
      fontWeight = props.fontWeight,
      fontStyle = props.fontStyle,
      style = props.style,
      clean = _objectWithoutProperties(props, ["translate", "scale", "rotation", "skewX", "skewY", "originX", "originY", "fontFamily", "fontSize", "fontWeight", "fontStyle", "style"]);

  var transform = [];

  if (originX != null || originY != null) {
    transform.push("translate(" + (originX || 0) + ", " + (originY || 0) + ")");
  }

  if (translate != null) {
    transform.push("translate(" + translate + ")");
  }

  if (scale != null) {
    transform.push("scale(" + scale + ")");
  }

  if (rotation != null) {
    transform.push("rotate(" + rotation + ")");
  }

  if (skewX != null) {
    transform.push("skewX(" + skewX + ")");
  }

  if (skewY != null) {
    transform.push("skewY(" + skewY + ")");
  }

  if (originX != null || originY != null) {
    transform.push("translate(" + (-originX || 0) + ", " + (-originY || 0) + ")");
  }

  if (transform.length) {
    clean.transform = transform.join(' ');
  }

  var styles = {};

  if (fontFamily != null) {
    styles.fontFamily = fontFamily;
  }

  if (fontSize != null) {
    styles.fontSize = fontSize;
  }

  if (fontWeight != null) {
    styles.fontWeight = fontWeight;
  }

  if (fontStyle != null) {
    styles.fontStyle = fontStyle;
  }

  clean.style = resolve(style, styles);
  return clean;
}

export var Circle = function (_Component) {
  _inherits(Circle, _Component);

  function Circle() {
    _classCallCheck(this, Circle);

    return _possibleConstructorReturn(this, _getPrototypeOf(Circle).apply(this, arguments));
  }

  _createClass(Circle, [{
    key: "render",
    value: function render() {
      return createElement('circle', prepare(this.props));
    }
  }]);

  return Circle;
}(Component);
export var ClipPath = function (_Component2) {
  _inherits(ClipPath, _Component2);

  function ClipPath() {
    _classCallCheck(this, ClipPath);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClipPath).apply(this, arguments));
  }

  _createClass(ClipPath, [{
    key: "render",
    value: function render() {
      return createElement('clipPath', prepare(this.props));
    }
  }]);

  return ClipPath;
}(Component);
export var Defs = function (_Component3) {
  _inherits(Defs, _Component3);

  function Defs() {
    _classCallCheck(this, Defs);

    return _possibleConstructorReturn(this, _getPrototypeOf(Defs).apply(this, arguments));
  }

  _createClass(Defs, [{
    key: "render",
    value: function render() {
      return createElement('defs', prepare(this.props));
    }
  }]);

  return Defs;
}(Component);
export var Ellipse = function (_Component4) {
  _inherits(Ellipse, _Component4);

  function Ellipse() {
    _classCallCheck(this, Ellipse);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ellipse).apply(this, arguments));
  }

  _createClass(Ellipse, [{
    key: "render",
    value: function render() {
      return createElement('ellipse', prepare(this.props));
    }
  }]);

  return Ellipse;
}(Component);
export var G = function (_Component5) {
  _inherits(G, _Component5);

  function G() {
    _classCallCheck(this, G);

    return _possibleConstructorReturn(this, _getPrototypeOf(G).apply(this, arguments));
  }

  _createClass(G, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          rest = _objectWithoutProperties(_this$props, ["x", "y"]);

      if ((x || y) && !rest.translate) {
        rest.translate = (x || 0) + ", " + (y || 0);
      }

      return createElement('g', prepare(rest));
    }
  }]);

  return G;
}(Component);
export var Image = function (_Component6) {
  _inherits(Image, _Component6);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, _getPrototypeOf(Image).apply(this, arguments));
  }

  _createClass(Image, [{
    key: "render",
    value: function render() {
      return createElement('image', prepare(this.props));
    }
  }]);

  return Image;
}(Component);
export var Line = function (_Component7) {
  _inherits(Line, _Component7);

  function Line() {
    _classCallCheck(this, Line);

    return _possibleConstructorReturn(this, _getPrototypeOf(Line).apply(this, arguments));
  }

  _createClass(Line, [{
    key: "render",
    value: function render() {
      return createElement('line', prepare(this.props));
    }
  }]);

  return Line;
}(Component);
export var LinearGradient = function (_Component8) {
  _inherits(LinearGradient, _Component8);

  function LinearGradient() {
    _classCallCheck(this, LinearGradient);

    return _possibleConstructorReturn(this, _getPrototypeOf(LinearGradient).apply(this, arguments));
  }

  _createClass(LinearGradient, [{
    key: "render",
    value: function render() {
      return createElement('linearGradient', prepare(this.props));
    }
  }]);

  return LinearGradient;
}(Component);
export var Path = function (_Component9) {
  _inherits(Path, _Component9);

  function Path() {
    _classCallCheck(this, Path);

    return _possibleConstructorReturn(this, _getPrototypeOf(Path).apply(this, arguments));
  }

  _createClass(Path, [{
    key: "render",
    value: function render() {
      return createElement('path', prepare(this.props));
    }
  }]);

  return Path;
}(Component);
export var Polygon = function (_Component10) {
  _inherits(Polygon, _Component10);

  function Polygon() {
    _classCallCheck(this, Polygon);

    return _possibleConstructorReturn(this, _getPrototypeOf(Polygon).apply(this, arguments));
  }

  _createClass(Polygon, [{
    key: "render",
    value: function render() {
      return createElement('polygon', prepare(this.props));
    }
  }]);

  return Polygon;
}(Component);
export var Polyline = function (_Component11) {
  _inherits(Polyline, _Component11);

  function Polyline() {
    _classCallCheck(this, Polyline);

    return _possibleConstructorReturn(this, _getPrototypeOf(Polyline).apply(this, arguments));
  }

  _createClass(Polyline, [{
    key: "render",
    value: function render() {
      return createElement('polyline', prepare(this.props));
    }
  }]);

  return Polyline;
}(Component);
export var RadialGradient = function (_Component12) {
  _inherits(RadialGradient, _Component12);

  function RadialGradient() {
    _classCallCheck(this, RadialGradient);

    return _possibleConstructorReturn(this, _getPrototypeOf(RadialGradient).apply(this, arguments));
  }

  _createClass(RadialGradient, [{
    key: "render",
    value: function render() {
      return createElement('radialGradient', prepare(this.props));
    }
  }]);

  return RadialGradient;
}(Component);
export var Rect = function (_Component13) {
  _inherits(Rect, _Component13);

  function Rect() {
    _classCallCheck(this, Rect);

    return _possibleConstructorReturn(this, _getPrototypeOf(Rect).apply(this, arguments));
  }

  _createClass(Rect, [{
    key: "render",
    value: function render() {
      return createElement('rect', prepare(this.props));
    }
  }]);

  return Rect;
}(Component);
export var Stop = function (_Component14) {
  _inherits(Stop, _Component14);

  function Stop() {
    _classCallCheck(this, Stop);

    return _possibleConstructorReturn(this, _getPrototypeOf(Stop).apply(this, arguments));
  }

  _createClass(Stop, [{
    key: "render",
    value: function render() {
      return createElement('stop', prepare(this.props));
    }
  }]);

  return Stop;
}(Component);
export var Svg = function (_Component15) {
  _inherits(Svg, _Component15);

  function Svg() {
    _classCallCheck(this, Svg);

    return _possibleConstructorReturn(this, _getPrototypeOf(Svg).apply(this, arguments));
  }

  _createClass(Svg, [{
    key: "render",
    value: function render() {
      return createElement('svg', prepare(this.props));
    }
  }]);

  return Svg;
}(Component);
export var Symbol = function (_Component16) {
  _inherits(Symbol, _Component16);

  function Symbol() {
    _classCallCheck(this, Symbol);

    return _possibleConstructorReturn(this, _getPrototypeOf(Symbol).apply(this, arguments));
  }

  _createClass(Symbol, [{
    key: "render",
    value: function render() {
      return createElement('symbol', prepare(this.props));
    }
  }]);

  return Symbol;
}(Component);
export var Text = function (_Component17) {
  _inherits(Text, _Component17);

  function Text() {
    _classCallCheck(this, Text);

    return _possibleConstructorReturn(this, _getPrototypeOf(Text).apply(this, arguments));
  }

  _createClass(Text, [{
    key: "render",
    value: function render() {
      return createElement('text', prepare(this.props));
    }
  }]);

  return Text;
}(Component);
export var TSpan = function (_Component18) {
  _inherits(TSpan, _Component18);

  function TSpan() {
    _classCallCheck(this, TSpan);

    return _possibleConstructorReturn(this, _getPrototypeOf(TSpan).apply(this, arguments));
  }

  _createClass(TSpan, [{
    key: "render",
    value: function render() {
      return createElement('tspan', prepare(this.props));
    }
  }]);

  return TSpan;
}(Component);
export var TextPath = function (_Component19) {
  _inherits(TextPath, _Component19);

  function TextPath() {
    _classCallCheck(this, TextPath);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextPath).apply(this, arguments));
  }

  _createClass(TextPath, [{
    key: "render",
    value: function render() {
      return createElement('textPath', prepare(this.props));
    }
  }]);

  return TextPath;
}(Component);
export var Use = function (_Component20) {
  _inherits(Use, _Component20);

  function Use() {
    _classCallCheck(this, Use);

    return _possibleConstructorReturn(this, _getPrototypeOf(Use).apply(this, arguments));
  }

  _createClass(Use, [{
    key: "render",
    value: function render() {
      return createElement('use', prepare(this.props));
    }
  }]);

  return Use;
}(Component);
export var Mask = function (_Component21) {
  _inherits(Mask, _Component21);

  function Mask() {
    _classCallCheck(this, Mask);

    return _possibleConstructorReturn(this, _getPrototypeOf(Mask).apply(this, arguments));
  }

  _createClass(Mask, [{
    key: "render",
    value: function render() {
      return createElement('mask', prepare(this.props));
    }
  }]);

  return Mask;
}(Component);
export var Marker = function (_Component22) {
  _inherits(Marker, _Component22);

  function Marker() {
    _classCallCheck(this, Marker);

    return _possibleConstructorReturn(this, _getPrototypeOf(Marker).apply(this, arguments));
  }

  _createClass(Marker, [{
    key: "render",
    value: function render() {
      return createElement('marker', prepare(this.props));
    }
  }]);

  return Marker;
}(Component);
export var Pattern = function (_Component23) {
  _inherits(Pattern, _Component23);

  function Pattern() {
    _classCallCheck(this, Pattern);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pattern).apply(this, arguments));
  }

  _createClass(Pattern, [{
    key: "render",
    value: function render() {
      return createElement('pattern', prepare(this.props));
    }
  }]);

  return Pattern;
}(Component);
export default Svg;